import {Crd, QueryRequestParamsBase, QueryResponseBase} from '@/interface';
import {ServiceMeshInstanceId} from '@/interface/serviceMesh';
import createInterface from '@/utils/axios';

export interface ParamsGetCrdListByInstanceId extends QueryRequestParamsBase {
    serviceMeshInstanceId: ServiceMeshInstanceId;
}

export interface ParamsCreateCrd {
    serviceMeshInstanceId: ServiceMeshInstanceId;
    content: string;
}

export interface ParamsGetCrd {
    serviceMeshInstanceId: ServiceMeshInstanceId;
    namespace: string;
    kind: string;
    name: string;
}

export interface ParamsUpdateCrd {
    serviceMeshInstanceId: ServiceMeshInstanceId;
    namespace: string;
    kind: string;
    name: string;
    content: string;
}

export interface ParamsDeleteCrd{
    serviceMeshInstanceId: ServiceMeshInstanceId;
    crdList: Crd[];
}

export const getCrdListByInstanceId = createInterface<
    ParamsGetCrdListByInstanceId,
    QueryResponseBase<Crd[]>
>('GET', '/api/csm/instance/{serviceMeshInstanceId}/crdList');

export const createCrd = createInterface<
    ParamsCreateCrd,
    Crd
>('POST', '/api/csm/instance/{serviceMeshInstanceId}/crd');

export const getCrd = createInterface<
    ParamsGetCrd,
    Crd
>('GET', '/api/csm/instance/{serviceMeshInstanceId}/{namespace}/crd?kind={kind}&name={name}');

export const updateCrd = createInterface<
    ParamsUpdateCrd,
    Crd
>('PUT', '/api/csm/instance/{serviceMeshInstanceId}/{namespace}/crd?kind={kind}&name={name}');

export const deleteCrd = createInterface<
    ParamsDeleteCrd,
    null
>('DELETE', '/api/csm/instance/{serviceMeshInstanceId}/crd');
